import { render, staticRenderFns } from "./reg-sms-check.vue?vue&type=template&id=73b88a28&"
import script from "./reg-sms-check.vue?vue&type=script&lang=js&"
export * from "./reg-sms-check.vue?vue&type=script&lang=js&"
import style0 from "./reg-sms-check.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports